import React from 'react';
import { numberWithCommas } from '@/lib/numberFormatting';

interface StatsProps {
  amount: number;
  currency?: boolean;
  units?: string;
  text: string;
  decimals?: number;
}

const Stats = ({ amount, decimals, currency, units, text }: StatsProps) => {
  return (
    <div className="flex flex-col gap-2">
      <p className="text-h4 bg-gradient-to-br from-primary to-secondary bg-clip-text text-transparent">
        {numberWithCommas(amount, decimals, currency)}{' '}
        {units && <span className="text-eyebrow font-black">{` ${units}`}</span>}
      </p>

      <p>{text}</p>
    </div>
  );
};

export default Stats;
